import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApprovalSubmissionInterface } from 'features/AdsManagement/@types/apiTypes'

export const SLICE_NAME = 'adsApprovalList'

type PaginationStateType = {
  next_cursor: string
  prev_cursor: string
}

interface AdsPrincipalDetailReduxInterface {
  isLoading: boolean
  approvalList: ApprovalSubmissionInterface[]
  pagination: PaginationStateType
}

const initialState: AdsPrincipalDetailReduxInterface = {
  isLoading: false,
  approvalList: [],
  pagination: { next_cursor: '', prev_cursor: '' },
}
const adsPrincipalDetailListSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setApprovalList: (state, action: PayloadAction<ApprovalSubmissionInterface[]>) => {
      state.approvalList = action.payload
    },
    setPagination: (state, action: PayloadAction<PaginationStateType>) => {
      state.pagination = action.payload
    },
  },
})

export const { setIsLoading, setApprovalList, setPagination } = adsPrincipalDetailListSlice.actions

export default adsPrincipalDetailListSlice.reducer
